import React, { useState, useEffect } from "react";
import axios from "axios";
import getAPI from "../../service/getAPI";
import { Table, Form } from "react-bootstrap";
import TableLoader from "../widgets/TableLoader";

function ShreeNandancourier() {
  const { master } = getAPI();
  const [list, setList] = useState([]); // Full data list
  const [filteredList, setFilteredList] = useState([]); // Filtered data list
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    name: "",
    phone_number: "",
    address: "",
    pincode: "",
    product: "",
    state: "",
    courier_date: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setIsLoading(true);
    try {
      let res = await axios.post(master.shree_nandan);
      setList(res.data.data);
      setFilteredList(res.data.data);
    } catch (err) {
      console.error(err);
    }
    setIsLoading(false);
  };

  // Function to handle column-wise filtering across all data
  const handleFilterChange = (e, key) => {
    const value = e.target.value.toLowerCase();
    setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));

    const filtered = list.filter((item) =>
      Object.keys(filters).every((filterKey) => {
        const filterValue = filterKey === key ? value : filters[filterKey]; // Update filter value dynamically
        const itemValue = item[filterKey]
          ? item[filterKey].toString().toLowerCase()
          : "";
        return itemValue.includes(filterValue);
      })
    );

    setFilteredList(filtered);
    setCurrentPage(1); // Reset to the first page after filtering
  };

  // Pagination calculations
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredList.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredList.length / itemsPerPage);

  return (
    <main id="main" className="main">
      <div className="pagetitle">
        <h1>Shree Nandan Courier Detail</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/">Masters</a>
            </li>
            <li className="breadcrumb-item active">Shree Nandan Courier</li>
          </ol>
        </nav>
      </div>

      <div className="row mt-3">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body pt-3">
              {/* React-Bootstrap Table */}
              <Table striped bordered hover responsive>
                <thead>
                  <tr className="table-secondary">
                    <th>No.</th>
                    <th>
                      Name
                      <Form.Control
                        type="text"
                        placeholder="Filter"
                        size="sm"
                        value={filters.name}
                        onChange={(e) => handleFilterChange(e, "name")}
                      />
                    </th>
                    <th>
                      Mobile No
                      <Form.Control
                        type="text"
                        placeholder="Filter"
                        size="sm"
                        value={filters.phone_number}
                        onChange={(e) => handleFilterChange(e, "phone_number")}
                      />
                    </th>
                    <th>
                      Address
                      <Form.Control
                        type="text"
                        placeholder="Filter"
                        size="sm"
                        value={filters.address}
                        onChange={(e) => handleFilterChange(e, "address")}
                      />
                    </th>
                    <th>
                      Pincode
                      <Form.Control
                        type="text"
                        placeholder="Filter"
                        size="sm"
                        value={filters.pincode}
                        onChange={(e) => handleFilterChange(e, "pincode")}
                      />
                    </th>
                    <th>
                      Product
                      <Form.Control
                        type="text"
                        placeholder="Filter"
                        size="sm"
                        value={filters.product}
                        onChange={(e) => handleFilterChange(e, "product")}
                      />
                    </th>
                    <th>
                      State
                      <Form.Control
                        type="text"
                        placeholder="Filter"
                        size="sm"
                        value={filters.state}
                        onChange={(e) => handleFilterChange(e, "state")}
                      />
                    </th>
                    <th>
                      Courier Date
                      <Form.Control
                        type="text"
                        placeholder="Filter"
                        size="sm"
                        value={filters.courier_date}
                        onChange={(e) => handleFilterChange(e, "courier_date")}
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>

                  {isLoading ? (<tr>
                    <td colSpan="8" className="text-center">
                      <TableLoader />
                    </td>
                  </tr>) : (<>{currentItems.length > 0 ? (
                    currentItems.map((shree_nandan_courier, index) => (
                      <tr key={index}>
                        <td>{shree_nandan_courier.shree_nandan_courier_id}</td>
                        <td>{shree_nandan_courier.name}</td>
                        <td>{shree_nandan_courier.phone_number}</td>
                        <td>{shree_nandan_courier.address}</td>
                        <td>{shree_nandan_courier.pincode}</td>
                        <td>{shree_nandan_courier.product}</td>
                        <td>{shree_nandan_courier.state}</td>
                        <td>{shree_nandan_courier.courier_date}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}</>)}
                </tbody>
              </Table>
            </div>

            {/* Pagination UI */}
            <div className="card-footer d-flex justify-content-between align-items-center">
              <div>
                Showing {indexOfFirstItem + 1} to{" "}
                {Math.min(indexOfLastItem, filteredList.length)} of{" "}
                {filteredList.length} entries
              </div>
              <nav aria-label="Page navigation">
                <ul className="pagination mb-0">
                  <li
                    className={`page-item ${currentPage === 1 ? "disabled" : ""
                      }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      &laquo; Prev
                    </button>
                  </li>

                  {/* Page Dropdown */}
                  <li className="page-item">
                    <Form.Select
                      className="custom-pagination-dropdown"
                      value={currentPage}
                      onChange={(e) => setCurrentPage(Number(e.target.value))}
                    >
                      {Array.from({ length: totalPages }, (_, i) => (
                        <option key={i + 1} value={i + 1}>
                          Page {i + 1}
                        </option>
                      ))}
                    </Form.Select>
                  </li>

                  <li
                    className={`page-item ${currentPage === totalPages ? "disabled" : ""
                      }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next &raquo;
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default ShreeNandancourier;
